import { BLACK_c, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 30rem;
  width: 100%;
  height: 70rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 6rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 20rem;
    height: auto;
  }
`;
export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
`;
export const Text1 = styled.div`
  font-weight: 700;
  font-size: 5.2rem;
  line-height: 9.2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 2.8rem;
    line-height: 5rem;
  }
`;
export const Text2 = styled.div`
  font-weight: 300;
  font-size: 2.2rem;
  line-height: 3.8rem;
  color: ${BLACK_c};
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 1.6rem;
    line-height: 2.8rem;
    display: block;
  }
`;
export const Table1 = styled.div`
  height: 46.2rem;
  display: flex;
  gap: 2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    flex-direction: column;
    height: auto;
  }
`;

export const ContentBox = styled.div`
  border: 1px solid #363636;
  border-radius: 10px;
  width: 28.5rem;
  height: 46rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    height: 40.2rem;
    padding-top: 3.5rem;
    padding-bottom: 3.7rem;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 4rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
  }
`;
export const Content1 = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > img {
    width: 13rem;
    height: 13rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > img {
      width: 13rem;
      height: 13rem;
    }
  }
`;

export const ContentText1 = styled.div`
  margin-top: 2rem;
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 4.2rem;
  min-height: ${(props) => (props.language === "en" ? "8.4rem" : "0")};
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 2.2rem;
    line-height: 3.8rem;
    width: ${(props) => (props.language === "ko" ? "100%" : "90%")};
    min-height: 0;
  }
`;
export const ContentText2 = styled.div`
  font-weight: 300;
  font-size: 1.8rem;
  line-height: 3.2rem;
  color: ${BLACK_c};
  width: ${(props) => (props.language === "ko" ? "22rem" : "22.9rem")};
  text-align: center;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 24.1rem;
    font-size: 1.6rem;
    line-height: 2.8rem;
    display: block;
    margin-top: 0.5rem;
  }
`;
export const Content2 = styled.div`
  height: 2.9rem;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.8rem;
  color: ${MAIN_GREEN};
  border-bottom: 1px solid ${MAIN_GREEN};
  cursor: pointer;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 1.4rem;
    line-height: 2.4rem;
  }
`;
